import { __decorate } from "tslib";
import Component from 'vue-class-component';
import Vue from 'vue';
import { VALIDATION_RULES } from "@/constants/ValidationRules";
import moment from 'moment';
import { BALANCES } from '@/constants/Balances';
import QrcodeVue from 'qrcode.vue';
let UnresolvedPayments = class UnresolvedPayments extends Vue {
    unresolvedPaymentHeaders = [
        { text: 'Jméno', value: '_instructor.data.name' },
        { text: 'Příjmení', value: '_instructor.data.surname' },
        { text: 'Částka', value: '_instructor.data.balance' },
        { text: 'Na účet', value: '_instructor.data.bankAccount' },
        { text: '', value: 'action', sortable: false },
    ];
    unresolvedPaymentDialogs = [];
    payingIndex = null;
    unresolvedPaymentRules = [
        VALIDATION_RULES.REQUIRED,
        VALIDATION_RULES.NUMBER,
    ];
    unresolvedPaymentTaxRules = [
        VALIDATION_RULES.REQUIRED,
        VALIDATION_RULES.UNSIGNED_NUMBER,
    ];
    async payout(payment, index) {
        if (!this.$refs.unresolvedPaymentDialog[0].validate()) {
            return;
        }
        // The dialog stays up until the transactions land, so the button can show the work.
        this.payingIndex = index;
        try {
            await this.$store.dispatch('transaction/store', {
                id: 'new-transaction',
                data: {
                    from: payment.instructor.data.balance >= 0 ? payment.id : 'cash',
                    to: payment.instructor.data.balance < 0 ? payment.id : 'cash',
                    value: payment.value - payment.tax,
                    dateTime: moment().format('YYYY-MM-DD HH:mm:ss'),
                    category: 'payout',
                    description: payment.instructor.data.balance < 0
                        ? 'Doplacení dlužné částky'
                        : 'Vyplacení mzdy',
                },
            });
            if (payment.tax > 0) {
                await this.$store.dispatch('transaction/store', {
                    id: 'new-transaction',
                    data: {
                        from: payment.id,
                        to: BALANCES.TAX_BALANCE,
                        value: payment.tax,
                        dateTime: moment().format('YYYY-MM-DD HH:mm:ss'),
                        category: 'payout',
                        description: 'Daň',
                    },
                });
            }
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.payingIndex = null;
            Vue.set(this.unresolvedPaymentDialogs, index, false);
        }
    }
    closeDialog(index) {
        Vue.set(this.unresolvedPaymentDialogs, index, false);
    }
    printUnresolvedPayment(header, item) {
        const index = header.value.substr(header.value.lastIndexOf('.') + 1);
        if (index === 'balance') {
            let balance = -item.data.balance;
            return `${balance.toLocaleString()},- Kč`;
        }
        if (index === 'bankAccount') {
            return item.data.bankAccount ? 'Ano' : 'Ne';
        }
        if (index === 'action') {
            return 'Vyrovnat';
        }
        return (index === 'name' || index === 'surname'
            ? (item.data[index] ?? '')
            : '').toString();
    }
    get unresolvedPayments() {
        return this.$store.getters['instructor/allUnresolvedPayments'];
    }
    get isAdmin() {
        return this.$store.getters['user/isAdmin'];
    }
};
UnresolvedPayments = __decorate([
    Component({
        components: {
            QrcodeVue,
        },
    })
], UnresolvedPayments);
export default UnresolvedPayments;
